"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var filterEmptyDateRange_1 = __importDefault(require("../../../../helpers/filterEmptyDateRange"));
var API_1 = require("../../../../middleware/API");
var transformUnavailableRange_1 = __importDefault(require("../../../../middleware/transformUnavailableRange"));
var transformWeekDaysArrayToObject_1 = __importDefault(require("../../../../middleware/transformWeekDaysArrayToObject"));
var formTypes_1 = require("../../../../types/formTypes");
var Button_1 = __importDefault(require("../../../atoms/Button/Button"));
var InputCheckboxes_1 = __importDefault(require("../../../atoms/InputCheckboxes/InputCheckboxes"));
var InputDayRange_1 = __importDefault(require("../../../atoms/InputDayRange/InputDayRange"));
var TabControls_1 = __importDefault(require("../../../molecules/TabControls/TabControls"));
var StepOne_styles_1 = __importDefault(require("./StepOne.styles"));
var StepOne = function (_a) {
    var formState = _a.formState, setStep = _a.setStep, handleInputChange = _a.handleInputChange;
    var _b = react_1.useState(false), error = _b[0], setError = _b[1];
    var onSubmit = function () {
        // update weekdays
        axios_1.default({
            method: 'post',
            url: '/api/availability/weekdays',
            data: JSON.stringify(transformWeekDaysArrayToObject_1.default(formState.daysNotAvailable.value)),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (res) {
            if (res.status > 201) {
                setError(true);
            }
            else {
                setError(false);
            }
        })
            .catch(function (error) {
            setError(true);
        });
        // add new value, create record
        filterEmptyDateRange_1.default(formState.rangesNotAvailable.value)
            .filter(function (item) { return item.state === formTypes_1.NEW; })
            .map(function (item) {
            API_1.postUnavailabilityData(transformUnavailableRange_1.default(item));
        });
        // update value
        formState.rangesNotAvailable.value
            .filter(function (item) { return item.state === formTypes_1.UPDATED; })
            .map(function (item) {
            API_1.putUnavailabilityData(item);
        });
        // delete value
        formState.rangesNotAvailable.value
            .filter(function (item) { return item.state === formTypes_1.DELETED; })
            .map(function (item) {
            API_1.deleteUnavailabilityData(item.id);
        });
        if (!error) {
            setStep(2);
        }
    };
    return (react_1.default.createElement(StepOne_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement(TabControls_1.default, { active: 1 }),
                react_1.default.createElement("h1", { className: "title" }, "1. Beschikbaarheid 2022 - 2023"),
                react_1.default.createElement("p", { className: "intro" },
                    "Je bent het hele schooljaar beschikbaar 2022-2023 (21 augustus 2021 - 07 juli 2023) om clinics te geven. Geef hier aan wanneer je ",
                    react_1.default.createElement("u", null, "niet"),
                    " beschikbaar bent dit schooljaar. In de volgende stap kan je dit per clinic nog specificeren. Tijdens de schoolvakanties is het sowieso niet mogelijk om clinics te geven."),
                react_1.default.createElement("form", null,
                    react_1.default.createElement(InputCheckboxes_1.default, __assign({}, formState.daysNotAvailable, { valueChanged: handleInputChange, buttonStyle: true, label: "Ik ben nooit beschikbaar op deze dag(en)", id: "daysNotAvailable", options: [
                            {
                                value: 'monday',
                                label: 'Maandag',
                            },
                            {
                                value: 'tuesday',
                                label: 'Dinsdag',
                            },
                            {
                                value: 'wednesday',
                                label: 'Woensdag',
                            },
                            {
                                value: 'thursday',
                                label: 'Donderdag',
                            },
                            {
                                value: 'friday',
                                label: 'Vrijdag',
                            },
                        ] })),
                    react_1.default.createElement("div", { className: "group" },
                        react_1.default.createElement(InputDayRange_1.default, __assign({}, formState.rangesNotAvailable, { label: 'Ik ben niet beschikbaar op deze specifieke data', name: 'datum', valueChanged: handleInputChange, id: 'rangesNotAvailable' })))),
                react_1.default.createElement(Button_1.default, { className: "button secondary", onClick: onSubmit },
                    react_1.default.createElement("span", null, "Door naar stap 2"),
                    react_1.default.createElement("svg", { className: "icon icon-arrow icon-right", "aria-hidden": "true" },
                        react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-right" })))))));
};
exports.default = StepOne;
